<template>
  <onboarding-step :step="step" v-if="statePart" color="primary">
    <loader :is-loading="onboardConnectorInProgress" color="primary">
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-list-item v-for="(detail, index) in statePart.details" :key="index">
              <v-list-item-icon>
                <v-icon :color="getColor(detail)">{{ getIcon(detail) }}</v-icon>
              </v-list-item-icon>
              <span>{{ detail }}</span>
            </v-list-item>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-jsoneditor
              v-if="typeJson"
              :plus="false"
              height="400px"
              @error="onError"
              @input="onInput"
              v-model="updateData">
            </v-jsoneditor>
            <geo-connector
              v-if="step.type === 'geo'"
              :updateData="updateData"
              @onError="onError"
              @onInput="onInput"
              @updateConnector="updateConnector"
            ></geo-connector>
            <user-connector
              v-if="step.type === 'user'"
              :updateData="updateData"
              @onError="onError"
              @onInput="onInput"
              @updateConnector="updateConnector"
            ></user-connector>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12 alert-changes">
            <v-alert
              v-show="changesNotSaved"
              icon="error_outline"
              text
              dense
              color="orange"
              transition="slide-y-transition"
            >
              {{ $t('onboarding.changesNotSaved') }}
            </v-alert>
          </v-col>
        </v-row>
        <v-row class="justify-center">
          <v-col cols="4">
            <v-btn
              block
              large
              :disabled="disabled"
              class="header-button"
              color="primary"
              @click="saveConnectorData">
              {{ $t(`save`) }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </loader>
  </onboarding-step>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import OnboardingStepMixin from '../../../mixins/onboardingStep.mixin';
import OnboardingStep from './OnboardingStep.vue';
import BookingChannelStepMixin from '../../../mixins/bookingChannelStep.mixin';
import GeoConnector from './connectors/GeoConnector.vue';
import UserConnector from './connectors/UserConnector.vue';

export default {
  name: 'connector-step',
  components: {
    OnboardingStep,
    GeoConnector,
    UserConnector,
  },
  mixins: [
    // order is important
    OnboardingStepMixin,
    BookingChannelStepMixin,
  ],
  props: {
    type: {
      type: String,
      required: true,
    },
    bookingChannelId: {
      type: String,
      required: true,
    },
    humanReadableId: {
      type: String,
      required: true,
    },
  },
  created() {
    this.updateData = _.cloneDeep(this.statePart.values);
  },
  watch: {
    statePart(newStatePart, oldStatePart) {
      if ((newStatePart !== oldStatePart && !this.dirty)) {
        this.updateData = _.cloneDeep(newStatePart.values);
      }
    },
    type(newType, oldType) {
      if (newType !== oldType) {
        this.updateData = _.cloneDeep(this.statePart.values);
      }
    },
  },
  data() {
    return {
      disabled: false,
      updateData: {},
      dirty: false,
    };
  },
  computed: {
    ...mapGetters({
      onboardConnectorInProgress: 'onboarding/onboardConnectorInProgress',
    }),
    changesNotSaved() {
      return this.dirty && !_.isEqual(this.statePart.values, this.updateData);
    },
    typeJson() {
      return !['geo', 'user'].includes(this.step.type);
    },
  },
  methods: {
    async saveConnectorData() {
      await this.$store.dispatch('onboarding/onboardConnector', {
        bookingChannelId: this.bookingChannelId,
        connector: this.updateData,
        connectorType: this.step.type,
        humanReadableId: this.humanReadableId,
      });
      this.dirty = false;
    },
    onError() {
      this.disabled = true;
    },
    onInput() {
      this.dirty = true;
      this.disabled = false;
    },
    updateConnector(updatedData) {
      this.updateData = updatedData;
    },
  },
};
</script>

<style scoped>
  .block_content {
    width: 100%;
  }
  .alert-changes {
    min-height: 80px;
  }
</style>

<style>
  .f-confirm {
    color: #fff;
    background: #000000 !important;
  }
</style>
